import {useContext} from 'react';

import {useLatest, useOnMount} from 'shared/web';

import {DialogCloseGuard, DialogCloseGuardContext} from '../components/DialogCloseGuardContext';

/**
 * Lets the content of a dialog keep it open, for example to confirm before unsaved input is lost.
 * One guard per dialog. Outside a dialog the guard is never called. The content's own Cancel
 * button asks too when it closes through `useDialogRequestClose`.
 */
export function useDialogCloseGuard(guard: DialogCloseGuard) {
  const context = useContext(DialogCloseGuardContext);
  const latestGuard = useLatest(guard);

  useOnMount(
    () => context?.setGuard((close) => latestGuard.current(close)),
    () => context?.setGuard(null)
  );
}
